module.exports = __webpack_public_path__ + "img/check.325bfb98.svg";